<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/8otBYf/tc-custom/9781638291831.jpg?1705540293273" alt="This image is the cover for the book Gullah Gravestones"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Gullah Gravestones
      </h1>
      <p class="bookDescription body article font2">
        <p class="FrameContents" style='margin:0cm;font-size:15px;font-family:"Grotesque Light",sans-serif;'><span style="color:black;">Steve Riley is a realtor who sells his friend and client a large tract of land in coastal South Carolina for a pricey condo project. The old Gullah graveyard there is specifically not to be disturbed but during initial grading, it accidentally happens. The land explodes, forming a large crater, coughing out hideous, angry skeletons killing all the workers and pulling them into the doomed abyss—a fiery pit of no escape! Shocking mayhem has now come to the once peaceful sea island!</span></p><p class="FrameContents" style='margin:0cm;font-size:15px;font-family:"Grotesque Light",sans-serif;'><br/></p><p class="FrameContents" style='margin:0cm;font-size:15px;font-family:"Grotesque Light",sans-serif;'><span style="color:black;">Unconcerned by the frightening supernatural event and events to come, Johnny is only upset about his ruined property and threatens Steve to get his money back. The two men become bitter enemies! Ironically, Steve’s twin daughters disappear. Filled with vengeance, Irish-tempered Steve believes Johnny kidnapped them! But did he? Out of desperation, Steve resorts to black magic in his quest to save his girls. After receiving amazing voodoo powers by an anomaly from the invisible world, will Steve find them? Can he deal with Johnny? And will the spirits rest again, under their Gullah Gravestones?  </span></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        William Hardy
      </h2>
      
      <p class="authorDescription body article"><p style="margin: 0mm; font-size: 15px; font-family: Calibri, sans-serif; text-align: justify;"><span style='font-family:"Times New Roman",serif;'>William Hardy lives in Spartanburg, SC, with his wife, Nancy. Not only being the published author of <em>Hell&rsquo;s Island</em>, he also is a founding member and guitarist with the J Teal Band, and wrote three songs on their album, <em>Cooks,</em> which was officially released on Rockadrome Records and distributed and sold worldwide. He is presently working on his next book, <em>Gullah Gravestones II</em>.</span></p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1f9e463d